import BaseEntity from './BaseEntity';
export default class Defect extends BaseEntity {
    constructor(data) {
        super();
        this.name = this.parseProperty(data, 'name');
        this.commitIssue = this.parseProperty(data, 'commitIssue');
        this.count = this.parseProperty(data, 'count');
        this.countDiff = this.parseProperty(data, 'countDiff');
        this.isError = this.parseProperty(data, 'isError');
        this.nodeType = this.parseProperty(data, 'nodeType');
        this.tool = this.parseProperty(data, 'tool');
        this.toolVersion = this.parseProperty(data, 'toolVersion');
    }
}
